import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import sundaraveldoc from '../../../../assets/images/Doctorsimages/sundravelDocImg.jpeg' // Ensure path is correct
import favicon from "../../../../assets/images/favicon.ico"
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'

const SundaravelDoc = () => {
  const navigate = useNavigate(); 
  
  useEffect(() => {
    document.title = "Dr. S. Sundaravel MDS | Best Oral Surgeon & Implantologist | hcura multispeciality clinics - All Over India";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Consult Dr. S. Sundaravel MDS, a renowned Oral Surgeon and Clinical Head at hcura multispeciality clinics. With 21 years of experience and 30,000+ implants placed, he specializes in full mouth rehabilitation across India. Book an expert consultation today."
      );
    }
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "best oral surgeon in India, top implantologist in India, hcura multispeciality clinics, full mouth rehabilitation specialist India, dental implant surgeon India, zygomatic implants expert, pterygoid implants specialist, All-on-4 dental implants India, All-on-6 dental implants India, facial trauma reconstruction surgeon, complex dental implant specialist"
      );
    }

    // Set canonical link
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute("href", "https://www.h-cura.com/doctors/dr-sundravel/implantologist");
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", "https://www.h-cura.com/doctors/dr-sundravel/implantologist");
      document.head.appendChild(canonicalLink);
    }

    // Set favicon
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }
  }, []);

  const handleDownloadPdf = () => {
    const container = document.querySelector('.veenadoc');
    container.classList.add('veenadoc-pdf-mode');
    const originalStyles = new Map();
    const allElements = container.querySelectorAll('*');

    allElements.forEach(el => {
      originalStyles.set(el, {
        transition: el.style.transition,
        animation: el.style.animation,
        transform: el.style.transform,
        filter: el.style.filter
      });
      el.style.transition = 'none';
      el.style.animation = 'none';
      el.style.transform = 'none';
      el.style.filter = 'none';
    });

    const heroSection = container.querySelector('.veenadoc-hero-section');
    if (heroSection) {
      heroSection.style.minHeight = 'auto';
      heroSection.style.padding = '40px 0';
    }

    const images = container.querySelectorAll('img');
    images.forEach(img => { img.style.opacity = '1'; });

    setTimeout(() => {
      html2canvas(container, {
        scale: 2,
        dpi: 300,
        useCORS: true,
        allowTaint: true,
        letterRendering: true,
        backgroundColor: '#ffffff',
        logging: false,
        windowWidth: container.scrollWidth,
        windowHeight: container.scrollHeight,
        scrollY: -window.scrollY,
        scrollX: -window.scrollX,
        imageTimeout: 0,
        removeContainer: false
      }).then(canvas => {
        container.classList.remove('veenadoc-pdf-mode');
        allElements.forEach(el => {
          const original = originalStyles.get(el);
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        });

        if (heroSection) {
          heroSection.style.minHeight = '';
          heroSection.style.padding = '';
        }

        const imgData = canvas.toDataURL('image/jpeg', 0.95);
        const pdf = new jsPDF('p', 'mm', 'a4', true);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;
        const marginLeft = 10;
        const marginRight = 10;
        const availableWidth = pdfWidth - marginLeft - marginRight;
        const scaleFactor = availableWidth / canvasWidth;
        const imgWidth = canvasWidth * scaleFactor;
        const imgHeight = canvasHeight * scaleFactor;
        const pages = Math.ceil(imgHeight / pdfHeight);

        for (let i = 0; i < pages; i++) {
          if (i > 0) { pdf.addPage(); }
          pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
        }
        pdf.save('Dr_S_Sundaravel_Profile.pdf');
      }).catch(error => {
        console.error('Error generating PDF:', error);
        container.classList.remove('veenadoc-pdf-mode');
      });
    }, 100);
  };

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. S. Sundaravel</span>
                  <span className="veenadoc-title-credentials">MDS</span>
                  <span className="veenadoc-title-location">hcura multispeciality clinics - All Over India</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    Clinical Head, Oral Surgeon and Implantologist performing advanced procedures at <strong>hcura multispeciality clinics</strong> across India. 
                    Placing implants since <strong>2005</strong> with <strong>21 years</strong> of expertise. 
                    With over <strong>30,000+</strong> successful implants, he is the leading specialist for full mouth rehabilitation nationwide.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button className="veenadoc-btn-primary-gradient" onClick={() => navigate('/bookconsultation')}>
                    <span className="veenadoc-btn-icon">📞</span>
                    <span>Book Consultation</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={sundaraveldoc} alt="Dr. S. Sundaravel MDS – Expert Oral Surgeon and Implantologist" className="veenadoc-doctor-image" title='Dr. S. Sundaravel MDS – Expert Oral Surgeon and Implantologist' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">
              <div className="veenadoc-article-main">
                
                <div className="veenadoc-article-block">
                  <h2>About Dr. S. Sundaravel MDS</h2>
                  <p>
                    Dr. S. Sundaravel MDS is widely recognized as a premier authority in Oral and Maxillofacial Surgery and a pioneering figure in the field of Implantology in India. Currently serving as the Clinical Head and Lead Implantologist at <strong>hcura multispeciality clinics</strong>, Dr. Sundaravel brings a rare combination of academic depth and massive clinical scale to his practice.
                  </p>
                  <p>
                    With a distinguished career spanning 21 years, he has been at the forefront of dental implant innovation since 2005, transforming the lives of thousands through his surgical precision and reconstructive expertise across various locations in India.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>National Clinical Leadership</h2>
                  <p>
                    Leading the surgical team at hcura multispeciality clinics, Dr. Sundaravel balances his high-volume clinical practice with a commitment to surgical excellence. His extraordinary track record includes the successful placement of over 30,000 implants, a milestone that places him among the most experienced implantologists globally.
                  </p>
                  <p>
                    He is specifically sought after for complex full mouth rehabilitation, where he utilizes advanced protocols to restore function and aesthetics for patients nationwide.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">MDS (Oral & Maxillofacial Surgery)</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">21+ Years</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Implantology & Full Mouth Rehab</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Locations:</span>
                      <span className="veenadoc-info-value">hcura multispeciality clinics - All Over India</span>
                    </div>
                  </div>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Surgical Mastery & Complex Cases</h2>
                  <p>
                    As a board-certified Oral and Maxillofacial Surgeon, he specializes in high-complexity procedures including Zygomatic and Pterygoid implants, All-on-4 and All-on-6 rehabilitation, and Sinus Lifts. His surgical mastery is now available to patients across India through the hcura network.
                  </p>
                  <p>
                    Patients searching for the best oral surgeon trust Dr. Sundaravel for his ability to handle the most intricate cases with predictable, life-changing outcomes.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Advanced Training & Onco-Surgery</h2>
                  <p>
                    His training is marked by specialized stints at world-class institutions such as NIMHANS for neurosurgery and trauma management, and the KIDWAI Medical Institute of Oncology. This multidisciplinary background allows him to approach every surgery with a comprehensive understanding of facial anatomy and patient safety.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Technology & Innovation at hcura</h2>
                  <p>
                    Dr. Sundaravel is a leader in the integration of technology in surgery, utilizing 3D Virtual Surgical Planning (VSP) and CAD/CAM guided implantology to ensure unmatched accuracy across hcura multispeciality clinics.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Research & Professional Recognition</h2>
                  <p>
                    A life member of the Association of Oral and Maxillofacial Surgeons of India, Dr. Sundaravel is also a widely published researcher, contributing significant findings to international journals on topics ranging from unicystic ameloblastoma to CBCT assessments.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Meeting Patient Needs Online</h2>
                  <p>
                    Dr. Sundaravel's expertise aligns perfectly with the most common search queries:
                  </p>
                  <ul className="veenadoc-search-queries-list">
                    <li>Best oral surgeon in India</li>
                    <li>Top implantologist at hcura clinics</li>
                    <li>Full mouth rehabilitation specialist India</li>
                    <li>Zygomatic implants expert India</li>
                    <li>All-on-4 dental implants All Over India</li>
                  </ul>
                </div>

                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Choose Dr. S. Sundaravel MDS for Precision Care</h2>
                  <p>
                    Choosing Dr. S. Sundaravel means selecting a surgeon who has defined the standard for modern implantology. Whether it is a single tooth replacement or a complex full-arch reconstruction, his 21 years of expertise provide the ultimate assurance of quality and safety.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>His mission:</strong> To restore function and confidence through surgical excellence and innovative implant solutions at hcura clinics nationwide.
                  </p>
                </div>
              </div>

              <div className="veenadoc-article-sidebar">
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote>
                      "Function First"
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. S. Sundaravel's Philosophy of Care</p>
                  </div>
                  <p>
                    He believes that every reconstructive procedure must not only look natural but perform perfectly for a lifetime, ensuring long-term wellness and functionality.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Practice Locations</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>hcura multispeciality clinics</h4>
                      <p>Performing Implants - All Over India</p>
                    </div>
                  </div>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Pan-India Presence</h4>
                      <p>Clinical Head & Lead Oral Surgeon</p>
                    </div>
                  </div>
                </div>

                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Experience world-class surgical care with Dr. Sundaravel's expert approach at an hcura clinic near you.</p>
                  <button className="veenadoc-sidebar-btn-primary" onClick={() => window.location.href = 'tel:+910000000000'}>
                    <span>📞</span>
                    <span>Schedule Appointment</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow/>

      <div className="bangloregfcblog-download-section">
        <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
          Download This Doctor profile as PDF
        </button>
      </div>
    </>
  )
}

export default SundaravelDoc
